export const SET_USER_SETTINGS = "USER:SET_USER_SETTINGS";
export const UPDATE_USER_SETTINGS = "USER:UPDATE_USER_SETTINGS";
export const SET_USER_INFO = "USER:SET_USER_INFO";
export const UPDATE_USER_INFO = "USER:UPDATE_USER_INFO";
export const SET_STATE_CHANGED_INFO = "USER:SET_STATE_CHANGED_INFO";
export const SET_STATE_CHANGED_SETTINGS = "USER:SET_STATE_CHANGED_SETTIGS";
export const SET_IS_LOADING = "USER:SET_IS_LOADING";
